'use strict';

(function (window, $) {
    const $window = $(window);
    const $rafflePageWrapper = $('.jwsdw-raffle-wrapper');
    const $continueButtons = $('.jwsdw-continue-button');
    const $raffleForm = $('.jwsdw-raffleForm');
    const mobileNavbarHeight = 64;

    /**
     * @description Method to scroll to the top of an element.
     * @param {jQuery} element jQuery element for which offset.top defines the scroll position
     * @param {number} offset - Optional offset parameter.
     * @returns {undefined}
     */
    function scrollTo(element, offset) {
        offset = offset || 0;
        $('html, body').animate({ 'scrollTop': element.offset().top + offset });
    }

    /**
     * @description Function to dispatch raffle submission custom event.
     * @param {jQuery} $form - The raffle form that was submitted
     * @param {Object} data - Response data from the server.
     * @returns {undefined}
     */
    function afterFormSubmit($form, data) {
        $form.find('button[type=submit]').spinner().stop();

        $form[0].dispatchEvent(new CustomEvent('raffle:submitted', {
            'detail': data && data.responseJSON
        }));
    }

    /**
     * @description Form submission handler.
     * @param {Event} e - A form submission event.
     * @returns {undefined}
     */
    function submitForm(e) {
        e.preventDefault();

        const $form = $(this);
        let payload = new FormData(e.currentTarget);
        if (!$form.valid()) {
            return;
        }

        const $fileInput = $form.find('input[type="file"]');
        if ($fileInput.length) {
            // Add each file under a unique key since SFCC does not support multiple files under the same key
            Array.from($fileInput[0].files).forEach((file, index) => {
                payload.append(`image_${index}`, file);
            });
        }

        const action = $form.prop('action');
        const method = $form.prop('method');
        payload.append(window.jwsdwSettings.csrfTokenName, window.jwsdwSettings.csrfTokenValue);
        payload.append('competitionId', window.jwsdwCompetitionConfigs.competitionID);

        $form.find('button[type=submit]').spinner().start();

        $.ajax({
            'url': action,
            'type': method,
            'data': payload,
            'dataType': 'json',
            'processData': false,
            'contentType': false,
            'success': (data) => {
                window.dataLayer = window.dataLayer || [];

                window.dataLayer.push({
                    'event': 'ce.misc',
                    'eventCategory': 'misc',
                    'eventAction': 'raffle',
                    'eventLabel': data.competitionId + (data.isNewUser ? ' Non-Member' : ' Member'),
                    'eventValue': undefined,
                    'nonInteraction': false
                });

                if (data.isNewUser) {
                    window.dataLayer.push({
                        'event': 'ce.misc',
                        'eventCategory': 'Misc',
                        'eventAction': 'Newsletter',
                        'eventLabel': 'signup',
                        'eventValue': undefined,
                        'nonInteraction': false
                    });

                    window.jwsdwApi.tracking.fireEvent('newsletter', {
                        'type': 'newsletterSubscriptionSuccessful'
                    });
                }

                let viewport = window.jwsdwUtil.uiUtils.getViewport();
                if (viewport === '\"small\"' || viewport === '\"medium\"') {
                    scrollTo($rafflePageWrapper, -mobileNavbarHeight);
                }
                $rafflePageWrapper.attr('data-state', 'registration-success');
            },
            'complete': (data) => afterFormSubmit($form, data),
            'error': (data) => {
                if (data.responseJSON && data.responseJSON.details && data.responseJSON.details.fieldErrors) {
                    $form.validate().showErrors(data.responseJSON.details.fieldErrors);
                }
            }
        });
    }

    /**
     * @description Function which handles browser's back button action in order to restore the initial state of the page.
     * @returns {undefined}
     */
    function handleBackButton() {
        $rafflePageWrapper.removeAttr('data-state');
    }

    /* Initialize birthday fields validation logic */
    $.validator.setDefaults({
        'rules': {
            'email': {
                'invalidvalue': true,
                'customemail': true
            },
            'dateOfBirth': {
                'checkDate': '#jwsdw-raffleForm-dateOfBirth'
            }
        }
    });

    /* Handling browser back button to allow for navigation through form states */
    $continueButtons.on('click', function () {
        let state = $(this).data('setState');
        if (state) {
            let scrollTarget = $(this).data('scrollTarget');
            history.pushState({ 'state': state }, '');

            requestAnimationFrame(() => {
                $rafflePageWrapper.attr('data-state', state);
                requestAnimationFrame(() => {
                    if (window.matchMedia('(max-width: 900px)').matches) {
                        scrollTo($(scrollTarget), -mobileNavbarHeight);
                    }
                });
            });
            $window.one('popstate', handleBackButton);
        }
    });

    /* Initializing form validation. */
    $raffleForm.validate();

    /* Handling competition form submission for new users */
    $raffleForm.on('submit', submitForm);
}(window, jQuery));
